import React, { createContext, useEffect, useState } from "react";
import { Post, Get, imageUrl } from "../services/ApiCalls";
import { ErrorMessage, handleToastSuccess } from "../components";
import { SaveUniqueData } from "../services/FirebaseCalls";
import { FIREBASE } from "../util/constants";
import { useNavigate } from "react-router-dom";

export const AuthContext = createContext();

const AuthProvider = (props) => {
  let navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [sendCode, setSendCode] = useState(0);
  const [loginData, setLoginData] = useState({});
  const [profileStatus, setProfileStatus] = useState({});

  const handle_login = async (payload, props) => {
    setIsLoading(true);
    try {
      let response = await Post("login", payload, true);
      handleToastSuccess(response.data.message, true);
      const FBRes = await SaveUniqueData({
        collectionName: FIREBASE.USERS_COllECTION,
        id: response.data.user.id,
        userData: response.data.user,
      });
      setIsLoading(false);
      props.setLoginModal(false);
      sessionStorage.setItem("user", JSON.stringify(response.data.user));
      sessionStorage.setItem("access_token", response.data.access_token);
      window.location.reload(false);
    } catch (error) {
      setIsLoading(false);
      ErrorMessage(error);
    }
  };

  const social_login_signup = async (payload, props, type) => {
    setIsLoading(true);
    try {
      let response = await Post(`login/${type}`, payload, true);
      handleToastSuccess(response.data.message, true);
      sessionStorage.setItem("user", JSON.stringify(response.data.user));
      sessionStorage.setItem("access_token", response.data.access_token);
      window.location.reload(false);
      setIsLoading(false);
      props.setLoginModal(false);
    } catch (error) {
      setIsLoading(false);
      ErrorMessage(error);
    }
  };

  const handle_register = async (payload, props) => {
    setIsLoading(true);
    try {
      let response = await Post("register", payload, true);
      handleToastSuccess(response.data.message, true);
      setIsLoading(false);
      props.setSignupModal(false);
    } catch (error) {
      setIsLoading(false);
      ErrorMessage(error);
    }
  };

  const delete_account = async (id) => {
    setIsLoading(true);
    try {
      let response = await Post("profile/delete", {});
      setIsLoading(false);
      handleToastSuccess(response.data.message, true);
      user_logout();
    } catch (error) {
      setIsLoading(false);
      ErrorMessage(error);
    }
  };

  const handle_sign_for_news_letter = async (payload, closeEmail) => {
    setIsLoading(true);
    try {
      let response = await Post("newsletter", payload, true);
      handleToastSuccess(response.data.message, true);
      setIsLoading(false);
      closeEmail(false);
    } catch (error) {
      setIsLoading(false);
      ErrorMessage(error);
    }
  };

  const send_email = async (payload, props) => {
    setIsLoading(true);
    try {
      let response = await Post("password/forgot", payload, true);
      props.onCloseForgotModal();
      handleToastSuccess(response.data.message, true);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      ErrorMessage(error);
    }
  };

  const reset_password = async (payload, props) => {
    setIsLoading(true);
    try {
      let response = await Post("password/reset", payload, true);
      props.onCloseResetModal();
      handleToastSuccess(response.data.message, true);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      ErrorMessage(error);
    }
  };

  const handle_contact = async (payload) => {
    setIsLoading(true);
    try {
      let response = await Post("contact", payload, true);
      handleToastSuccess(response.data.msg, true);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      ErrorMessage(error);
    }
  };

  const handle_change_password = async (payload, props) => {
    setIsLoading(true);
    try {
      let response = await Post("profile/change-password", payload);
      handleToastSuccess(response.data.msg, true);
      props.onClose();
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      ErrorMessage(error);
    }
  };

  const user_data = async () => {
    let userData = sessionStorage.getItem("user");
    userData && setLoginData(JSON.parse(userData));
  };

  const user_logout = async () => {
    sessionStorage.removeItem("user");
    sessionStorage.removeItem("access_token");
    navigate("/");
    window.location.reload(false);
  };

  const handle_profile_image = async (payload) => {
    setIsLoading(true);
    try {
      let response = await Post("profile/image", payload);
      sessionStorage.setItem("user", JSON.stringify(response.data.user));
      handleToastSuccess(response.data.msg, true);
      user_data();
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      ErrorMessage(error);
    }
  };

  const handle_user_profile = async (payload) => {
    setIsLoading(true);
    try {
      let response = await Post("profile/update", payload);
      sessionStorage.setItem("user", JSON.stringify(response.data.user));
      handleToastSuccess(response.data.msg, true);
      user_data();
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      ErrorMessage(error);
    }
  };

  const profile_all_status = async () => {
    setIsLoading(true);
    try {
      let response = await Get("profile/stats");
      setProfileStatus(response.data.stats);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  function changeCodeStatus() {
    setSendCode(0);
  }

  const verfiy_email = async () => {
    setIsLoading(true);
    try {
      let response = await Post("profile/verify/email", {});
      handleToastSuccess(response.data.message, true);
      setSendCode(1);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      ErrorMessage(error);
    }
  };

  const confirm_verfiy_email = async (payload, onClose) => {
    setIsLoading(true);
    try {
      let response = await Post("profile/verify/email/confirm", payload);
      handleToastSuccess(response.data.message, true);
      user_data();
      setSendCode(0);
      onClose();
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      ErrorMessage(error);
    }
  };

  const verfiy_phone = async (payload) => {
    setIsLoading(true);
    try {
      let response = await Post("profile/verify/phone", payload);
      sessionStorage.setItem("user", JSON.stringify(response.data.user));
      handleToastSuccess(response.data.message, true);
      setIsLoading(false);
      setSendCode(2);
    } catch (error) {
      setIsLoading(false);
      ErrorMessage(error);
    }
  };

  const confirm_verfiy_phone = async (payload, onClose) => {
    setIsLoading(true);
    try {
      let response = await Post("profile/verify/phone/confirm", payload);
      handleToastSuccess(response.data.message, true);
      handleToastSuccess(response.data.message, true);
      user_data();
      setIsLoading(false);
      onClose();
      setSendCode(0);
    } catch (error) {
      setIsLoading(false);
      ErrorMessage(error);
    }
  };

  const verfiy_identity = async (payload, onClose) => {
    setIsLoading(true);
    try {
      let response = await Post("profile/verify/id", payload);
      handleToastSuccess(response.data.message, true);
      onClose();
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      ErrorMessage(error);
    }
  };

  function google_login(res, props) {
    console.log("se ~ res", res);
    if (res?.profileObj) {
      let payload = {
        email: res.profileObj?.email,
        firstname: res.profileObj?.givenName,
        lastname: res.profileObj?.familyName,
      };
      social_login_signup(payload, props, "google");
    }
  }

  function facebook_login(res) {
    console.log("se ~ res", res);
  }

  function twitter_login(res) {
    console.log("se ~ res", res);
  }

  return (
    <AuthContext.Provider
      value={{
        handle_login,
        handle_register,
        isLoading,
        profileStatus,
        send_email,
        sendCode,
        handle_contact,
        reset_password,
        user_data,
        user_logout,
        loginData,
        handle_profile_image,
        imageUrl,
        handle_user_profile,
        profile_all_status,
        handle_change_password,
        changeCodeStatus,
        verfiy_email,
        confirm_verfiy_email,
        verfiy_identity,
        verfiy_phone,
        confirm_verfiy_phone,
        google_login,
        facebook_login,
        twitter_login,
        handle_sign_for_news_letter,
        delete_account,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};
export default AuthProvider;
